






















  import Vue from 'vue'
  import Component from 'vue-class-component'
//   import moduleStore from '../../store/videoEditor';
  import PageState from "../../store/state";
  @Component({
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      currRatio:{
        default:'9:16'
      },
      title:{
        type:String,
        default:'选择效果'
      },
      confirmText:{
        type:String,
        default:'确定'
      },
      showClose: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      visible: {
        handler(val) {
          this.show = val
        },
        immediate: true
      }
    },
    components: {
    }
  })
//   @moduleStore.initVuex({
//     mutationNames: moduleStore.mutationNames,
//     actionNames: moduleStore.actionNames
//   })
  export default class PopupContainer extends Vue{
    [x: string]: any;
    state = new PageState();
    show = false;
    created(moduleData: IinjectDatas) {
      this.state = <PageState>moduleData.state;
    }
    closePopup() {
      this.$emit('close')
    }
    /**
     * 确定
     */
    confirmChoose() {
      console.log('---确认选择')
      this.$emit('confirm')
    }
    submitRate(){
      //触发对应的函数
      console.log('---popup提交选择')//todo
      this.$emit('close')
    }
  }
